import { render, staticRenderFns } from "./TimeRestrictionsTable.vue?vue&type=template&id=4b7a33c4&scoped=true&"
import script from "./TimeRestrictionsTable.vue?vue&type=script&lang=js&"
export * from "./TimeRestrictionsTable.vue?vue&type=script&lang=js&"
import style0 from "./TimeRestrictionsTable.vue?vue&type=style&index=0&id=4b7a33c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a33c4",
  null
  
)

export default component.exports